import ClientMonitor from 'skywalking-client-js'
import { useGlobSetting } from '@admin/hooks/setting'

export default function initSkywalking() {
  const { skywalkCollector } = useGlobSetting()
  if (skywalkCollector) {
    ClientMonitor.register({
      collector: skywalkCollector,
      service: 'admin',
      serviceVersion: 'v2.0.0',
      noTraceOrigins: ['https://aegis.qq.com'],
    })
  }
}
